export function getISTDateTime() {
  const options = { timeZone: "Asia/Kolkata" };
  const istDate = new Date().toLocaleString("en-IN", options);
  const date = new Date(istDate);

  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const yyyy = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  const ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12 || 12; // Convert 0 → 12 and 13–23 → 1–11

  return `${mm}/${dd}/${yyyy}, ${hours}:${minutes}:${seconds} ${ampm}`;
}
